<div class='PreviewContent'>
  <div class='PreviewContent-info mt-3 p-5 d-flex flex-column'>
    <div class='PreviewContent-form'>
      <mat-horizontal-stepper #stepper *ngIf='dataReady' [selectedIndex]='selectedIndex'>
        <mat-step *ngFor='let item of templates; let index = index' [stepControl]='getGroup(item.content_id)'>
          <form [formGroup]='formGroup'>
            <ng-template matStepLabel>{{ item.content_template }}</ng-template>

            <h2 class='title__page'>Preview Content  {{ item.content_template }}</h2>
            <div *ngIf='index == 0' class='content'>
              <p><b>Subject Line: {{ item.subject }}</b></p>
              <p>{{ item.greeting }}</p>
              <app-html-viewer [html]='item.content_attention'></app-html-viewer>
              <app-html-viewer [html]='item.first_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.second_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.content_closing'></app-html-viewer>
              <hr>
              <app-html-viewer [html]='signature'></app-html-viewer>
              <app-html-viewer [html]='item.content_details'></app-html-viewer>
            </div>

            <div *ngIf='index == 1' class='content'>
              <p><b>Subject Line: {{ item.subject }}</b></p>
              <p>{{ item.greeting }}</p>
              <app-html-viewer [html]='item.content_opening'></app-html-viewer>
              <app-html-viewer [html]='item.second_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.content_attention'></app-html-viewer>
              <app-html-viewer [html]='item.first_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.content_closing'></app-html-viewer>
              <hr>
              <app-html-viewer [html]='signature'></app-html-viewer>
              <app-html-viewer [html]='item.content_details'></app-html-viewer>
            </div>

            <div *ngIf='index == 2' class='content'>
              <p><b>Subject Line: {{ item.subject }}</b></p>
              <p>{{ item.greeting }}</p>
              <app-html-viewer [html]='item.content_opening'></app-html-viewer>
              <app-html-viewer [html]='item.first_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.second_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.content_closing'></app-html-viewer>
              <hr>
              <app-html-viewer [html]='signature'></app-html-viewer>
              <app-html-viewer [html]='item.content_details'></app-html-viewer>
            </div>

            <div *ngIf='index == 3' class='content'>
              <p><b>Subject Line: {{ item.subject }}</b></p>
              <p>{{ item.greeting }}</p>
              <app-html-viewer [html]='item.content_opening'></app-html-viewer>
              <app-html-viewer [html]='item.first_benefit'></app-html-viewer>
              <app-html-viewer [html]='item.content_attention'></app-html-viewer>
              <app-html-viewer [html]='item.content_closing'></app-html-viewer>
              <hr>
              <app-html-viewer [html]='signature'></app-html-viewer>
              <app-html-viewer [html]='item.content_details'></app-html-viewer>
            </div>

            <div class='d-flex flex-row w-100'>
              <ng-container *ngIf='(index < templates.length-1)'>
                <app-button (click)='editTemplate(item.content_id, index)' [color]="'orange'" [size]="'normal'"
                            [style]="'filled'"
                            [text]="'Edit'"></app-button>
                <app-button (click)='stepperNext()' [size]="'normal'" [text]="'Next'" class='ms-3'
                            color='blue'></app-button>
              </ng-container>
              <ng-container *ngIf='(index == templates.length-1)'>
                <app-button (click)='editTemplate(item.content_id, index)' [color]="'orange'" [size]="'normal'"
                            [style]="'filled'"
                            [text]="'Edit'"></app-button>
                <app-button (click)='onFinish()' [color]="'blue'" [size]="'normal'" [text]="'Finish'"
                            class='ms-3'></app-button>
              </ng-container>
            </div>
          </form>
        </mat-step>
      </mat-horizontal-stepper>

    </div>
  </div>
</div>
